import React from 'react';
import { motion } from 'framer-motion';
import GridItem from '../components/GridItem';
import GridImage from '../components/GridImage';

// TYPES
interface Props {
  props: GridModuleProps;
}
interface JunoVars {
  buckets: string;
  enforce_end_date: boolean;
  enforce_start_date: boolean;
  per_page: number;
  required_tags: Function;
  sort: number;
}
interface GridModuleProps {
  grid_class: string;
  title: string;
  vars: JunoVars;
  titleAlign: string;
  rowParams?: any;
}
interface JunoContentData {
  content: any;
  success: string;
}

export default function GridModule({ props }: Props): JSX.Element {
  const { vars, title, grid_class = 'GridItem', rowParams = {} } = props;

  const [data, setData] = React.useState<JunoContentData>({
    content: [],
    success: 'pending',
  });

  const aUrl = 'crowdhub_api_v2/api_content_oneAndOnlyList.php';

  React.useEffect(() => {
    //@ts-ignore
    App.INSTANCE.mApi.Request(
      //@ts-ignore
      CrowdHub_App.CONFIG.BASE_URL + aUrl,
      vars,
      function (aData) {
        if (aData.success == 'true') {
          setData(aData);
        } else {
          console.error(aData);
        }
      },
      function (error) {
        console.error(error);
        setData({
          content: [],
          success: 'false',
        });
      },
    );
  }, []);

  return (
    <div className={'grid_module'}>
      <div className={`grid_module_title primary-font-family`}>
        <div className={`title`}>{title}</div>
      </div>
      <motion.div initial="hidden" animate="visible" variants={list} className={`grid_container`}>
        {data.success == 'pending' ? (
          <div
            className={`react_loading_container`}
            dangerouslySetInnerHTML={{
              //@ts-ignore
              __html: HGEN.image({
                //@ts-ignore
                src: Resources.resources.PRELOADER_ICON.src,
                //@ts-ignore
                alt: Resources.resources.PRELOADER_ICON.alt,
              }),
            }}
          />
        ) : data.content.length > 0 ? (
          data.content.map((content, index) => {
            return <GridImage key={content.content_id} content={content} index={index} vars={vars} {...rowParams} />;
          })
        ) : (
          <>No Results</>
        )}
      </motion.div>
    </div>
  );
}

// Framer variants
const list = {
  visible: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      when: 'afterChildren',
    },
  },
};
